import React, { useState } from 'react';
import { Filter, ChevronDown } from 'lucide-react';

const ImageFilters = ({ 
  categories = {}, 
  selectedCategory = 'all', 
  onCategoryChange,
  showCount = true,
  className = ''
}) => {
  const [isOpen, setIsOpen] = useState(false);

  // Default categories if none provided
  const defaultCategories = {
    all: 'All Categories',
    fire_fighting_equipment: 'Fire Fighting Equipment',
    fire_detection_systems: 'Fire Detection Systems',
    emergency_lighting: 'Emergency Lighting',
    evacuation_routes: 'Evacuation Routes',
    electrical_safety: 'Electrical Safety',
    hazardous_materials: 'Hazardous Materials',
    general_conditions: 'General Conditions',
    signage: 'Signage',
    sprinkler_systems: 'Sprinkler Systems',
    emergency_preparedness: 'Emergency Preparedness',
    housekeeping: 'Housekeeping',
    legal_compliance: 'Legal Compliance',
    other: 'Other'
  };

  const availableCategories = Object.keys(categories).length > 0 ? categories : defaultCategories;

  const handleCategorySelect = (category) => {
    onCategoryChange(category);
    setIsOpen(false);
  };

  const getCategoryCount = (category) => {
    if (!showCount || !categories[category]) return '';
    return ` (${categories[category]})`;
  };

  const getSelectedCategoryLabel = () => {
    return availableCategories[selectedCategory] || availableCategories.all;
  };

  return (
    <div className={`relative ${className}`}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center space-x-2 px-4 py-2 bg-white border border-gray-300 rounded-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
      >
        <Filter className="w-4 h-4 text-gray-500" />
        <span className="text-sm font-medium text-gray-700">
          {getSelectedCategoryLabel()}
        </span>
        <ChevronDown 
          className={`w-4 h-4 text-gray-500 transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`} 
        />
      </button>

      {/* Dropdown menu */}
      {isOpen && (
        <div className="absolute top-full left-0 mt-1 w-64 bg-white border border-gray-200 rounded-md shadow-lg z-50 max-h-80 overflow-y-auto">
          <div className="py-1">
            {Object.entries(availableCategories).map(([key, label]) => (
              <button
                key={key}
                onClick={() => handleCategorySelect(key)}
                className={`w-full text-left px-4 py-2 text-sm hover:bg-gray-100 transition-colors ${
                  selectedCategory === key 
                    ? 'bg-blue-50 text-blue-700 font-medium' 
                    : 'text-gray-700'
                }`}
              >
                <div className="flex items-center justify-between">
                  <span>{label}</span>
                  {showCount && key !== 'all' && categories[key] && (
                    <span className="text-xs text-gray-500 ml-2">
                      {categories[key]}
                    </span>
                  )}
                </div>
              </button>
            ))}
          </div>
        </div>
      )}

      {/* Click outside to close */}
      {isOpen && (
        <div 
          className="fixed inset-0 z-40" 
          onClick={() => setIsOpen(false)}
        />
      )}
    </div>
  );
};

export default ImageFilters;